module.exports = __webpack_public_path__ + "static/media/05(3).94e01baf.jpg";